<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="activity-list p-bottom-xl-1 row-130-25 max">
    <!-- eslint-disable vue/no-v-html -->
    <div class="container max-content text-s-1-b">
      <div
        v-for="(activity, index) in block.attivita"
        :key="index"
        class="activity"
      >
        <div class="titolo" v-html="activity.titolo"></div>
        <div class="testo" v-html="activity.testo"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityList',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
